<template>
  <div>
    <v-dialog
      :ref="name"
      v-model="show"
      :return-value.sync="output"
      persistent
      width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          v-model="output"
          :label="label"
          readonly
          v-on="on"
          :dense="dense"
        ></v-text-field>
      </template>
      <v-time-picker
        v-if="show"
        v-model="output"
        full-width
      >
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="$refs[name].save(output)">OK</v-btn>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'ClockWidget',
  props: {
    startTime: {
      type: [String, Number]
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: "time"
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      output: this.startTime
    }
  },
  watch: {
    output(newValue) {
      this.$emit('time', newValue);
    },
    startTime(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.output = newValue;
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss">
</style>
